Vue.component('katalog', {
  template: '#vue-katalog',
  data: function () {
    return {
      cover: '',
      success: false,
      params: {
        nameAndSurname: {
          value: '',
          validation: ''
        },
        address: {
          value: '',
          validation: ''
        },
        city: {
          value: '',
          validation: ''
        },
        zipCode: {
          value: '',
          validation: ''
        },
        notes: {
          value: '',
          validation: ''
        },
        email: {
          value: '',
          validation: ''
        },
        emailRepeat: {
          value: '',
          validation: ''
        },
        phone: {
          value: '',
          validation: ''
        },
        agreement: {
          value: false,
          text: '',
          validation: ''
        }
      }
    }
  },
  created: function () {
    setPageTitle("Zamawainie katalogu" + mainMetaTitleStatic);
    setMeta("description", 'Zamów nasz katalog już dziś! ' + getMeta("description"));
  },
  mounted: function () {
    const self = this;
    self.getZgoda();
  },
  watch: {
    'params.nameAndSurname.value': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.validateEmptyInput('nameAndSurname');
      }
    },
    'params.address.value': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.validateEmptyInput('address');
      }
    },
    'params.city.value': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.validateEmptyInput('city');
      }
    },
    'params.zipCode.value': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.validateEmptyInput('zipCode');
        this.validateZipCodeInput();
      }
    },
    'params.email.value': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.validateEmptyInput('email');
        this.validateEmailInput();
      }
    },
    'params.emailRepeat.value': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.validateEmailInput();
      }
    },
    'params.agreement.value': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.validateAgreementInput();
      }
    }
  },
  methods: {
    getZgoda: function () {
      const self = this;

      $.post("/back/Katalog.php", { action: 'zgoda' }, function (result, textStatus) {
        if (result.agreement !== null) {
          self.params.agreement.text = result.agreement;
          self.cover = result.cover;
        }
        serverBus.$emit('loading_end');
      }, "json");
    },
    saveKatalog: function () {
      const self = this;

      if (self.validateForm()) {
        serverBus.$emit('loading_start');
        let data = {
          nameAndSurname: self.params.nameAndSurname.value,
          address: self.params.address.value,
          city: self.params.city.value,
          zipCode: self.params.zipCode.value,
          email: self.params.email.value,
          emailRepeat: self.params.emailRepeat.value,
          notes: self.params.notes.value,
          phone: self.params.phone.value,
          agreement: self.params.agreement.value
        };
        $.post("/back/Katalog.php", { action: 'save', katalog: data }, function (result, textStatus) {
          serverBus.$emit('loading_end');
          if (result.status == "OK") {
            self.success = true;
          } else {
            alert(result.details);
          }
        }, "json");
      }
    },
    validateForm: function () {
      const self = this;

      let emptyValidation = true;
      if (!self.validateEmptyInput('nameAndSurname')) {
        emptyValidation = false;
      }
      if (!self.validateEmptyInput('address')) {
        emptyValidation = false;
      }
      if (!self.validateEmptyInput('city')) {
        emptyValidation = false;
      }
      if (!self.validateEmptyInput('zipCode')) {
        emptyValidation = false;
      }
      if (!self.validateEmptyInput('email')) {
        emptyValidation = false;
      }
      if (!self.validateAgreementInput()) {
        emptyValidation = false;
      }
      if (!emptyValidation) {
        return false;
      }
      if (!self.validateEmailInput()) {
        return false;
      }
      if (!self.validateZipCodeInput()) {
        return false;
      }

      return true;
    },
    validateEmptyInput: function (name) {
      const self = this;
      if (self.params.hasOwnProperty(name)) {
        if (self.params[name].value == '') {
          self.params[name].validation = locales('components.katalog.js.error_empty');
          return false;
        } else {
          self.params[name].validation = "";
          return true;
        }
      }
    },
    validateEmailInput: function () {
      const self = this;
      if (self.validateEmailAddress(self.params.email.value) === false) {
        self.params.email.validation = locales('components.katalog.js.error_email');
        return false;
      } else {
        self.params.email.validation = "";
      }
      if (self.params.email.value != self.params.emailRepeat.value) {
        self.params.emailRepeat.validation = locales('components.katalog.js.error_email_repeat');
        return false;
      } else {
        self.params.emailRepeat.validation = "";
      }
      return true;
    },
    validateZipCodeInput: function () {
      const self = this;
      if (self.validateZipCode(self.params.zipCode.value) === false) {
        self.params.zipCode.validation = locales('components.katalog.js.error_zipcode');
        return false;
      } else {
        self.params.zipCode.validation = "";
      }
      return true;
    },
    validateAgreementInput: function () {
      const self = this;
      if (self.params.agreement.value == false) {
        self.params.agreement.validation = locales('components.katalog.js.error_agreement');
        return false;
      } else {
        self.params.agreement.validation = "";
      }
      return true;
    },
    validateEmailAddress: function (email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validateZipCode: function (zipCode) {
      const re = /^\d\d-\d\d\d$/;
      return re.test(zipCode);
    }
  }
});
